import {usersHaveLoadedSelector} from '../../../data/users.js'
import SettingsPanel from '../SettingsPanel.js'
import List from './List.js'
import {useSelector} from '../../../store.js'

export default function Users() {
  const hasLoaded = useSelector(usersHaveLoadedSelector)

  return (
    <SettingsPanel header="User Settings">
      <div className="row">{hasLoaded && <List />}</div>
    </SettingsPanel>
  )
}
